import { Stack, Box, IconButton, Typography, Snackbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useState } from 'react';
import CopyMonkeyAIIcon from '../../../assets/images/CopyMonkey_Logo_Monkey.png'
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';

interface IAIChatMessageProps {
  role: string;
  chatMessage: string;
}

const AIChatMessage: React.FC<IAIChatMessageProps> = ({ role, chatMessage }) => {
  const theme = useTheme();

  return (
    <Stack
        direction={'row'}
        gap={{
          mobile: '20px',
          tablet: '40px',
        }}
        p={{
          mobile: '10px',
          laptop: '20px',
        }}
      >
        <Box
          alignSelf={'flex-start'}
          sx={{ width: '80', fontSize: '36px' }}
        >
          {role === 'assistant' ? (
            <img src={CopyMonkeyAIIcon} width={'35px'} alt="AI Chat" />
          ) : (
            <AccountCircleRoundedIcon 
              fontSize='large'
              sx={{ color: theme.custom.palette.primary.default }}
            />
          )}
        </Box>

        <Box alignSelf={'center'}>
          <Typography
            variant="h5"
            sx={{whiteSpace: 'pre-line'}}
          >
            {chatMessage}
          </Typography>
        </Box>
      </Stack>
  );
};

export default AIChatMessage;
